import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import Layout from '@/components/Layout'
import SEO from '@/components/Seo'
import styled from '@emotion/styled'
import { graphql, useStaticQuery } from 'gatsby'
import groupBy from '@/util/groupBy'
import dasherize from '@/util/dasherize'
import Hero from '@/components/Feature/Candidatos/Hero'
let animations = {
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.4,
    },
  },
}

const Main = styled(motion.div)``

import Pregunta from '@/components/Feature/Elegidos/Pregunta'

const PreguntaTemplate = props => {
  return (
    <Main initial="exit" animate="enter" exit="exit" variants={animations}>
      <Layout>
        <SEO />
        <Pregunta {...props} />
      </Layout>
    </Main>
  )
}

export default PreguntaTemplate

export const query = graphql`
  query preguntaQuery($id: String!) {
    pregunta: googlePreguntasSheet(id: { eq: $id }) {
      id
      numero: n_mero
      enunciado
      sobreEstaPregunta
      campoEnPlanilla
      consideradaEnMapa
      orden
      slug
      bajada
      descripcion: descripci_n
    }
  }
`
